<template>
  <div class="tips">
    <p>
      声明：本平台展示的废旧物资价格行情相关数据、资讯等信息仅供参考。
    </p>
    <p>
      本平台对相关信息及数据准确性不承担责任。
    </p>
  </div>
</template>

<script>
export default {
  name: 'MyTips'
}
</script>
<style lang="less" scoped>
.tips {
  color: rgba(107, 114, 128, 1);
  text-align: left;
  margin: 20px 0 10px;
  text-align: center;
  line-height: 30px;
  padding-bottom: 20px;
}
</style>
